import React from 'react';
import { CheckIcon } from 'lucide-react';
type VolumeCardProps = {
  label: string;
  title: string;
  subtitle: string;
  intro: string[];
  listLabel: string;
  items: string[];
  outro: string;
  finalLine: string;
};
export function VolumeCard({
  label,
  title,
  subtitle,
  intro,
  listLabel,
  items,
  outro,
  finalLine
}: VolumeCardProps) {
  return <article className="overflow-hidden rounded-md border border-slate-200 bg-white" data-id="element-176" data-mp="y58c7yj150vi">
      <div className="flex items-start gap-2 bg-blue-950 px-3 py-2.5" data-id="element-177" data-mp="1usmpxnxaujpu">
        <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center rounded-sm bg-green-600" aria-hidden data-id="element-178" data-mp="1pvcrjirxmxpv">
          <CheckIcon className="h-3 w-3 text-white" strokeWidth={4} data-id="element-179" data-mp="1l21vmcons1cq" />
        </span>
        <h3 className="text-sm font-extrabold uppercase leading-tight text-white md:text-base" data-id="element-180" data-mp="1h186jfzhcgi9">
          <span className="text-amber-400" data-id="element-181" data-mp="2dkxlewpmjfdx">{label}</span> — {title}
        </h3>
      </div>
      <div className="px-3 py-3 md:px-4" data-id="element-182" data-mp="28sxkp21qciga">
        <p className="text-sm font-bold leading-snug text-sky-600 md:text-base" data-id="element-183" data-mp="28r2v3afik25v">{subtitle}</p>
        <div className="mt-1.5 space-y-1 text-sm leading-snug text-slate-600 md:text-base" data-id="element-184" data-mp="37csfnytxy3h1">
          {intro.map(p => <p key={p} data-id="element-185" data-mp="2xm799p80zunk">{p}</p>)}
        </div>
        <p className="mt-2.5 text-sm font-bold text-blue-950" data-id="element-186" data-mp="2xlo4793h50qy">{listLabel}</p>
        <ul className="mt-1 grid gap-x-5 gap-y-1 text-sm leading-snug text-slate-600 md:grid-cols-2" data-id="element-187" data-mp="32kinsd99mtc4">
          {items.map(item => <li key={item} className="flex items-start gap-2" data-id="element-188" data-mp="2ok7t0z4u4ulo">
              <span className="mt-[7px] h-1.5 w-1.5 shrink-0 rounded-full bg-amber-500" aria-hidden data-id="element-189" data-mp="2tlndoq33oz3j" />
              <span data-id="element-190" data-mp="2eoeiflaofb6j">{item}</span>
            </li>)}
        </ul>
        <p className="mt-2.5 text-sm leading-snug text-slate-600 md:text-base" data-id="element-191" data-mp="2jm6dupaj5ffh">{outro}</p>
        <p className="mt-2 text-xs font-extrabold uppercase leading-tight text-sky-600 md:text-sm" data-id="element-192" data-mp="cw85lry0k7qr">{finalLine}</p>
      </div>
    </article>;
}